// Arabic strings for recurring visits and room booking policy — DEVELOPMENT DRAFT by Claude (PD-011); unreviewed until decision H-10.
import type { enRecurrence } from './en-recurrence.ts';
import type { Message } from './types.ts';

export const arRecurrence: { readonly [K in keyof typeof enRecurrence]: Message } = {
  // ------------------------------------------------------------ API and validation
  'api.roomCapacityWarning': 'تتسع هذه الوجهة لـ{capacity} أشخاص؛ وفي الزيارة {count}. لا تسمح سياسة الحجز بذلك إلا بعد تأكيدك.',
  'api.seriesRoomWarning': 'في بعض المواعيد عدد أشخاص يفوق سعة الوجهة. أكّد للمتابعة.',
  'api.seriesImpact': 'يسحب هذا التغيير موافقات المواعيد اللاحقة. راجِع ثم أكّد.',
  'api.notSeries': 'هذه الزيارة ليست جزءاً من سلسلة متكررة.',
  'api.occurrenceClosed': 'هذا الموعد ملغى أو انتهى. اختر موعداً لاحقاً.',
  'api.seriesOccurrencesForbidden': 'لا يمكنك تغيير كل المواعيد اللاحقة في هذه السلسلة، لذا لم يُغيَّر شيء.',
  'v.recurrenceEnd': 'اختر تاريخ انتهاء أو عدد المواعيد.',
  'v.exclusionUnmatched': 'هذه التواريخ ليست من مواعيد السلسلة: {dates}.',
  'v.bookingPolicyNotApplicable': 'لا يمكن حجز إلا القاعات والمناطق ومواقف السيارات والوجهات الأخرى.',

  // ------------------------------------------------------------ recurrence editor (PB-04-02)
  'rr.repeat': 'تكرار',
  'rr.frequency': 'التكرار',
  'rr.frequency.weekly': 'أسبوعياً',
  'rr.frequency.monthly': 'شهرياً',
  'rr.monthly.by': 'التكرار في',
  'rr.monthly.dayOfMonth': 'اليوم نفسه من الشهر',
  'rr.monthly.nthWeekday': 'يوم الأسبوع نفسه من الشهر',
  'rr.day': 'يوم الشهر',
  'rr.nth': 'أيّ',
  'rr.nth.1': 'الأول',
  'rr.nth.2': 'الثاني',
  'rr.nth.3': 'الثالث',
  'rr.nth.4': 'الرابع',
  'rr.nth.5': 'الخامس',
  'rr.nth.last': 'الأخير',
  'rr.weekday': 'يوم الأسبوع',
  'rr.weekdayLong.1': 'الاثنين',
  'rr.weekdayLong.2': 'الثلاثاء',
  'rr.weekdayLong.3': 'الأربعاء',
  'rr.weekdayLong.4': 'الخميس',
  'rr.weekdayLong.5': 'الجمعة',
  'rr.weekdayLong.6': 'السبت',
  'rr.weekdayLong.7': 'الأحد',
  'rr.end': 'تنتهي',
  'rr.end.until': 'في تاريخ',
  'rr.end.count': 'بعد عدد من المواعيد',
  'rr.until': 'تاريخ الانتهاء',
  'rr.count': 'عدد المواعيد',
  'rr.countHint': 'تُحتسب التواريخ المستثناة ضمن هذا العدد؛ أما التواريخ غير الموجودة فلا تُحتسب.',
  'rr.exclusions': 'تخطَّ هذه التواريخ',
  'rr.exclusionsHint': 'تواريخ من السلسلة بلا زيارة، مثل عطلة رسمية.',
  'rr.exclusionDate': 'تاريخ للتخطي',
  'rr.addExclusion': 'إضافة تاريخ',
  'rr.removeExclusion': 'إزالة {date}',
  'rr.preview': 'المواعيد',
  'rr.previewCount': { zero: 'لا مواعيد', one: 'موعد واحد', two: 'موعدان', few: '{count} مواعيد', many: '{count} موعداً', other: '{count} موعد' },
  'rr.previewMore': '… و{count} غيرها',
  'rr.previewLoading': 'جارٍ حساب التواريخ…',
  'rr.previewIncomplete': 'اختر تاريخ البدء والنمط وطريقة انتهاء السلسلة لعرض التواريخ.',
  'rr.excludedTitle': 'تخطّيتَها أنت',
  'rr.skippedTitle': 'تواريخ غير موجودة (تُتخطّى ولا تُنقل أبداً)',
  'rr.skipped.no_such_day': '{month}: لا يوجد هذا اليوم في الشهر',
  'rr.skipped.no_such_weekday': '{month}: لا يوجد يوم الأسبوع هذا في الشهر',
  'rr.dstNote': 'يحتفظ كل موعد بالوقت المحلي نفسه في {zone}، حتى عند تغيير الساعة.',

  // ------------------------------------------------------------ this / this-and-future (PD-472 – PD-474)
  'rr.scope.legend': 'طبّق هذا التغيير على',
  'rr.scope.this': 'هذا الموعد فقط',
  'rr.scope.following': 'هذا الموعد وكل المواعيد اللاحقة',
  'rr.scope.followingHint': 'تبقى المواعيد السابقة وسجلّها كما هي. يُفحص كل موعد لاحق على حدة، ويُطلب اعتماده مجدداً إذا كان التغيير جوهرياً.',
  'rr.scope.visitorsNote': 'لإضافة زوار، غيّر موعداً واحداً في كل مرة.',
  'rr.impactBody': {
    zero: 'لن يُطلب اعتماد أي موعد مجدداً ({decisions} قرارات مسحوبة). المتغيّر: {fields}.',
    one: 'سيُطلب اعتماد موعد واحد مجدداً ({decisions} قرارات مسحوبة). المتغيّر: {fields}.',
    two: 'سيُطلب اعتماد موعدين مجدداً ({decisions} قرارات مسحوبة). المتغيّر: {fields}.',
    few: 'سيُطلب اعتماد {count} مواعيد مجدداً ({decisions} قرارات مسحوبة). المتغيّر: {fields}.',
    many: 'سيُطلب اعتماد {count} موعداً مجدداً ({decisions} قرارات مسحوبة). المتغيّر: {fields}.',
    other: 'سيُطلب اعتماد {count} موعد مجدداً ({decisions} قرارات مسحوبة). المتغيّر: {fields}.',
  },
  'rr.result.title': 'تغيير السلسلة',
  'rr.result.split': {
    zero: 'تغيّر من {date}. لا مواعيد سابقة.',
    one: 'تغيّر من {date}. بقي موعد سابق واحد دون تغيير.',
    two: 'تغيّر من {date}. بقي موعدان سابقان دون تغيير.',
    few: 'تغيّر من {date}. بقيت {count} مواعيد سابقة دون تغيير.',
    many: 'تغيّر من {date}. بقي {count} موعداً سابقاً دون تغيير.',
    other: 'تغيّر من {date}. بقي {count} موعد سابق دون تغيير.',
  },
  'rr.result.inPlace': 'تغيّر من {date}.',
  'rr.result.cancelled': {
    zero: 'أُلغي من {date}. لا مواعيد سابقة.',
    one: 'أُلغي من {date}. بقي موعد سابق واحد دون تغيير.',
    two: 'أُلغي من {date}. بقي موعدان سابقان دون تغيير.',
    few: 'أُلغي من {date}. بقيت {count} مواعيد سابقة دون تغيير.',
    many: 'أُلغي من {date}. بقي {count} موعداً سابقاً دون تغيير.',
    other: 'أُلغي من {date}. بقي {count} موعد سابق دون تغيير.',
  },
  'rr.outcome.updated': 'حُدِّث',
  'rr.outcome.unchanged': 'لا تغيير',
  'rr.outcome.cancelled': 'أُلغي',
  'rr.outcome.failed': 'لم يتغيّر — {message}',
  'rr.viewSeries': 'عرض السلسلة',

  // ------------------------------------------------------------ cancel
  'rr.cancel.scope': 'إلغاء',
  'rr.cancel.this': 'هذا الموعد فقط',
  'rr.cancel.following': 'هذا الموعد وكل المواعيد اللاحقة',
  'rr.cancel.followingHint': 'تبقى المواعيد السابقة كما هي. يُلغى كل موعد لاحق على حدة؛ ويبقى الموجودون في الموقع فيه حتى تُسجَّل مغادرتهم.',

  // ------------------------------------------------------------ series view
  'rr.series.title': 'سلسلة متكررة',
  'rr.series.intro': 'كل موعد زيارة مستقلة لها موافقاتها وروابطها. تغيير موعد واحد لا يلغي المواعيد الأخرى أبداً.',
  'rr.series.col.date': 'الموعد',
  'rr.series.col.when': 'الوقت ({zone})',
  'rr.series.col.visit': 'الزيارة',
  'rr.series.col.planning': 'الحالة',
  'rr.series.col.approval': 'الموافقات',
  'rr.series.hidden': {
    zero: 'لا مواعيد مخفية.',
    one: 'موعد واحد غير معروض لأنك لا تستطيع رؤيته.',
    two: 'موعدان غير معروضين لأنك لا تستطيع رؤيتهما.',
    few: '{count} مواعيد غير معروضة لأنك لا تستطيع رؤيتها.',
    many: '{count} موعداً غير معروض لأنك لا تستطيع رؤيتها.',
    other: '{count} موعد غير معروض لأنك لا تستطيع رؤيتها.',
  },
  'rr.series.parts': 'أجزاء هذه السلسلة',
  'rr.series.part.original': 'الأصل، من {date}',
  'rr.series.part.continued': 'مستمرة من {date}',
  'rr.series.ended.split': 'تغيّرت من {date} فصاعداً (استمرت كجزء جديد)',
  'rr.series.ended.cancelled': 'أُلغيت من {date} فصاعداً',
  'rr.series.rule.weekly': 'أسبوعياً أيام {days}',
  'rr.series.rule.monthlyDay': 'شهرياً في اليوم {day}',
  'rr.series.rule.monthlyNth': 'شهرياً في {weekday} {nth}',
  'rr.series.rule.until': 'حتى {date}',
  'rr.series.rule.count': { zero: 'لا مواعيد', one: 'موعد واحد', two: 'موعدان', few: '{count} مواعيد', many: '{count} موعداً', other: '{count} موعد' },
  'rr.series.back': 'العودة إلى الزيارة',
  'rr.series.empty': 'لا مواعيد.',

  // ------------------------------------------------------------ room booking policy (PB-12-03)
  'rr.roomWarn.title': 'عدد الأشخاص يفوق سعة الوجهة',
  'rr.roomWarn.record': 'إذا تابعت، يُسجَّل تأكيدك في الزيارة.',
  'rr.roomWarn.item': '{date}: السعة {capacity}، وفي الزيارة {count}',
  'rr.roomWarn.confirm': 'المتابعة رغم تجاوز السعة',
  'rr.roomWarnings.title': 'تحذيرات سعة مؤكَّدة',
  'rr.roomWarnings.item': 'أكّد {name} حضور {count} أشخاص في وجهة تتسع لـ{capacity} ({at})',
  'loc.field.bookingPolicy': 'سياسة الحجز',
  'loc.field.bookingPolicyHint': 'ما يحدث عندما تتداخل زيارة مع حجز آخر أو يفوق عدد أشخاصها السعة. يسري التغيير على الحجوزات اللاحقة.',
  'loc.booking.block': 'منع: لا حجوزات متداخلة؛ ويُرفض تجاوز السعة',
  'loc.booking.warn': 'تحذير: يُسمح بالتداخل؛ ويحتاج تجاوز السعة إلى تأكيد',
  'loc.booking.none': 'لا حجز: السعة للعلم فقط',
  'loc.bookingShort.block': 'تمنع التداخل',
  'loc.bookingShort.warn': 'تحذّر',
  'loc.bookingShort.none': 'لا حجز',
};
